import { z } from 'zod';

const baseFields = {
  name: z.string().trim().min(1, '名稱不能為空').max(100, '名稱最多 100 字'),
  remark: z.string().trim().max(500, '備註最多 500 字').optional().or(z.literal('')),
  permissionIds: z.array(z.string()),
};

export const roleCreateSchema = z.object({
  code: z.string().trim().min(1, '代碼不能為空')
    .regex(/^[a-z][a-z0-9_]*$/, '代碼須為小寫英數與底線，且以英文字母開頭（例：material_editor）'),
  ...baseFields,
});

export const roleEditSchema = z.object({
  code: z.string().optional(),
  ...baseFields,
});

export const ROLE_FIELD_LABELS = {
  code: '代碼',
  name: '名稱',
  remark: '備註',
};
